import { Injectable } from '@angular/core';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';
import { ExportFileFacade, LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { DemurrageDetentionListState } from './demurrage-detention-list.state';
import {
  DemurrageDetentionListDto,
  DemurrageDetentionShipmentModel,
} from '../models/demurrage-detention/demurrage-detention-list.model';
import {
  DemurrageDetentionExportToFileStart,
  DemurrageDetentionInitialState,
  DemurrageDetentionLoad,
  DemurrageDetentionStatisticsLoad,
} from './demurrage-detention-list.actions';
import { DemurrageDetentionSearchCriteria } from '../models/shipment.model';
import { ShipmentQuickFilterModel } from '../../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ExportDialogComponent } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class DemurrageDetentionListFacade implements SetInitialStateFacade, LoadDataFacade, ExportFileFacade {
  listDto$: Observable<DemurrageDetentionListDto> = this.store.select(DemurrageDetentionListState.getListDto);
  items$: Observable<DemurrageDetentionShipmentModel[]> = this.store.select(DemurrageDetentionListState.getItems);
  containerChargesStatistic$: Observable<ShipmentQuickFilterModel[]> = this.store.select(
    DemurrageDetentionListState.getContainerChargesStatistics,
  );
  loaded$: Observable<boolean> = this.store.select(DemurrageDetentionListState.getLoaded);
  statisticLoaded$: Observable<boolean> = this.store.select(DemurrageDetentionListState.getStatisticLoaded);
  totalElements$: Observable<number> = this.store.select(DemurrageDetentionListState.getTotalElements);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Shipment)
      .subscribe((searchCriteria: DemurrageDetentionSearchCriteria) => {
        this.store.dispatch(new DemurrageDetentionLoad({ searchCriteria }));
      });
  }

  loadStatistics(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Shipment)
      .subscribe((searchCriteria: DemurrageDetentionSearchCriteria) => {
        this.store.dispatch(new DemurrageDetentionStatisticsLoad({ searchCriteria }));
      });
  }

  startExportToFile(
    reportName: string,
    dialogRef: MatDialogRef<ExportDialogComponent>,
    navigationNeeded: boolean,
  ): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Shipment)
      .subscribe((searchCriteria: DemurrageDetentionSearchCriteria) => {
        const { filters, dndStatisticFilter } = searchCriteria;
        this.store.dispatch(
          new DemurrageDetentionExportToFileStart({
            reportName,
            searchRequestView: {
              filter: filters,
              statisticFilter: dndStatisticFilter,
            },
            dialogRef,
            navigationNeeded,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new DemurrageDetentionInitialState());
  }
}
